export const FETCH_LISTADEINFORMACOES = "FETCH_LISTADEINFORMACOES";
export const GERAR_PDF = "GERAR_PDF";